import axios from "axios";
import { BASE_URL } from "./baseUrls";

import {
  InterceptorRequestHandler,
  InterceptorResponseErrorHandler,
  InterceptorResponseHandler,
} from "./InterceptorHandler";

// get region value from local storage
const AuthService = axios.create({ baseURL: BASE_URL.AUTH });

// Service Interceptors Configuration
AuthService.interceptors.request.use((req) => InterceptorRequestHandler(req));

// Dynamically, setting baseURL based on active region
AuthService.interceptors.request.use((req) => {
  const baseUrl = BASE_URL.AUTH;
  req.baseURL = baseUrl;
  return req;
});

AuthService.interceptors.response.use(
  (res) => {
    InterceptorResponseHandler(res);
    return res;
  },
  (error) => {
    InterceptorResponseErrorHandler(error);
    return error;
  }
);

export default AuthService;
